<template>
  <div class="fullscreen-centered">Logging in...</div>
</template>

<script>
export default {
  mounted () {
    this.$store.dispatch('postLoginTasks')
      .then(() => {
        this.$router.push('/mine')
      })
      .catch(err => {
        throw err
      })
  }
}
</script>
